import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { MembershipCloudUser } from 'src/features/membership/types';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/cloud-users/for-current-user/`;

type QueryFnType = typeof queryFn;

interface DTO {
    membershipId: string;
    parkingId: string;
}
const queryFn = ({ membershipId, parkingId }: DTO): Promise<MembershipCloudUser> => {
    return axios.get(formatResourcePath(RESOURCE, { membershipId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetCurrentCloudUser, RESOURCE as GET_CURRENT_CLOUD_USER_RESOURCE };
